<template>
    <div class="faqs-col-content">
        <div class="faqs">
            <h4>Will HMI cover emergency cases in non-affiliated hospitals?</h4>
            <p>
                By reimbursement only. When a hospital is not affiliated with HMI, there is no mutual understanding
                between the two parties. Thus, HMI cannot issue a Letter Of Authorization (LOA) to cover the medical
                expenses incurred during the confinement or the availment of the Emergency Room of the non-affiliated
                hospital. Medical expenses must be filed for reimbursement with HMI, that will be subject to approval,
                and may be paid according to the limits of your plan or program type. HMI reserves the right to
                validate that any HMI affiliated hospital was not used because to have done so would entail delay
                which could possibly result in death, serious disability, or significant jeopardy to the HMI member's
                condition.
            </p>
        </div>

        <div class="faqs">
            <h4>
                What do I do if there is no available room under my program type during
                my time of admission?
            </h4>
            <p>
                If you wish to avoid paying additional room and board charges, we advise you to get a room lower
                than your enrolled program. Should you wish to get a room rate higher than your enrolled program,
                you will be charged for room and board excess, plus incremental charges for the ancillary services.
            </p>
            <p>
                Coordinate with the hospital's Admissions Department to request room transfer to your enrolled room
                category. If your condition permits, you may request for a transfer to another HMI-affiliated hospital
                from the HMI Hospital Operations Department by calling the following numbers: (02) 8811-1313,
                (02) 8865-3700 or (02) 7752-0552 and press zero (0), or email medical@hmi.com.ph for assistance.
            </p>
        </div>

        <div class="faqs">
            <h4>
                During confinement, who is responsible for filing my PhilHealth with the
                hospital? What happens if I fail to file it?
            </h4>
            <p>
                You as an HMI Member are responsible for the filing of your PhilHealth Form, either personally or
                through an authorized representative, during your period of confinement. In case you fail to file
                it during your admission period, you will have to pay the amount corresponding to the PhilHealth
                portion and you may apply for reimbursement with PhilHealth. The HMI In-patient Coordinator/Liaison
                Officer will remind you to submit the required forms, but they are not responsible for the actual
                filing.
            </p>
            <p>
                If you are not an active PhilHealth member, you must pay the PhilHealth portion billed by the hospital
                prior to your discharge.
            </p>
        </div>

        <div class="faqs">
            <h4>What is a Pre-Existing Medical Condition?</h4>
            <p>
                A Pre-Existing Medical Condition or Pre-Existing Condition (PEC) is an illness, condition, or injury
                which you already had or have prior to enrolling with HMI regardless if you are aware of it or not,
                or is considered to have been in existence within the first 12 months of membership.  Some examples
                are, but not limited to: Asthma, Systemic Allergies, Hypertension, Diabetes, Cancer, Lithiasis,
                Chronic Diseases, Hemorrhoids, etc.
            </p>
        </div>

        <div class="faqs">
            <h4>If I have a Pre-existing Condition (PEC), will it be covered?</h4>
            <p>
                Unless otherwise stated in the Service Agreement between your company and HMI, your PEC will be
                covered from the first year of HMI membership, provided that:
            </p>
            <ul v-for="(preexisting, i) in preexistings" :key="i">
                <li>{{ preexisting }}</li>
            </ul>
        </div>

        <div class="faqs">
            <h4>Why do I need to pay my Neurologist's professional fees?</h4>
            <p>
                As per guidelines set by the Philippine Neurological Association, the professional fees of
                Neurologists are on a 'cash basis' policy for all plan-holders/members within the HMO industry,
                and not just for members of HMI.
            </p>
            <p>
                After paying for the cost of the professional fees, you may file a claim for reimbursement at the
                HMI Head Office - Claims Department. The value of the reimbursement will be based on HMI's Relative
                Value Scale (RVS). For the procedures performed, HMI will cover the member's availment according to
                your HMI Plan. Kindly note that HMI policies on Exclusions, Limitations and Non-coverage shall apply
                based on your final diagnosis.
            </p>
        </div>

        <div class="faqs">
            <h4>
                If I choose to be admitted under the service of my own doctor, will HMI
                cover my confinement?
            </h4>
            <p>
                Regretfully, HMI will not cover your confinement. Under the HMI Service Agreement, you must be
                admitted under the care of the HMI PIC in order for your HMI benefits to be extended to you.
            </p>
            <p>
                You may request from the HMI Medical Provider Relations Unit (MPRU) to reach out to your personal
                doctor to be affiliated with HMI. Kindly call the following numbers: (02) 8811-1313, (02) 8865-3700
                or (02) 7752-0552. Kindly note that it is your doctor's decision whether or not to be HMI-affiliated.
            </p>
        </div>

        <div class="faqs">
            <h4>Are Vaccination and immunization covered?</h4>
            <p>
                HMI shall cover the cost of consultation and administration, except the cost of the vaccines,
                which may be subject to the member's program limitation.
            </p>
        </div>
        <div class="faqs">
            <h4>Does HMI offer teleconsultation services?</h4>
            <p>
                Yes. HMI Offers teleconsultation services through the affiliated hospitals and clinics offering
                such services. Teleconsultations are also possible through mobile or web applications affiliated
                with HMI such as Doctor Anywhere. Simply download and install the Doctor Anywhere application on your
                device, then tag yourself as an HMI member.
            </p>

            <div class="proc-img">
                <img style="width: 95%; margin: auto; align-content: center;" src="../../../../assets/DA-HMI-Insurance-Tagging-1.webp" alt="">
            </div>
            <div class="proc-img">
                <img style="width: 95%; margin: auto; align-content: center;" src="../../../../assets/DA-HMI-Insurance-Tagging-2.webp" alt="">
            </div>

            <ul v-for="(teleCon, i) in teleCons" :key="i">
                <li>{{ teleCon }}</li>
            </ul>
        </div>

        <div class="faqs">
            <h4>Can I request for an HMI Letter of Approval (LOA) or Out-patient Approval Number (OPAN) online?</h4>
            <p>
                Yes. Should you need coverage approval for the procedures requested by your HMI-affiliated Doctor,
                or need to consult an HMI-affiliated Doctor, you may request for the issuance of an Out-Patient
                Approval Authorization Number (OPAN) form for consultations, laboratory and other diagnostic tests,
                or a Letter Of Authorization (LOA) for out-patient or in-patient medical/surgical procedures,
                by sending an email to medical@hmi.com.ph with the following details:
            </p>
            <p>Email subject: OPD Approval Request </p>
            <p>Email Content:</p>
            <ul v-for="(loaOpan1, i) in loaOpan1s" :key="i">
                <li>{{ loaOpan1 }}</li>
            </ul>
            <p>
                And for any and all queries on medical benefits and coverage, you may call our 24/7 hotlines:
                (02) 8811-1313, (02) 7752-0552 and (02) 8865-3700 and press zero (0).
            </p>
        </div>

        <div class="faqs">
            <h4>What services are available at HMICare Clinics?</h4>

            <ul v-for="(service, i) in services" :key="i">
                <li>{{ service }}</li>
            </ul>
            <p>
                The services of HMICare Clinic & Diagnostic Center are constantly evolving,
                and may have updated services not listed above. To know if a doctor or procedure you need might
                be available, or to schedule an appointment, kindly refer to the contact details at the back cover
                of this Membership Manual.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        preexistings: [
            'Such condition/s are properly disclosed in your HMI Application Form.',
            'That no benefits were covered herein based on the said condition.',
            'No Waiver of medical benefits was issued.',
            'The member renews his/her membership for another term in the immediately succeeding year without interruption.'
        ],
        services: [
            'Medical Consultation',
            'Fully-Equipped Laboratory',
            'X-Ray',
            '2D & Ultrasound',
            'ECG & Treadmill Stress Test',
            'ACU (Annual Check-Up)',
            'Dental Services',
            'OFW & Pre-Employment Exam',
            'Executive Check-up',
            'Minor Procedures',
            'Rehab / Physical Therapy',
            'Drug & HIV Testing',
            'Psychological Testing',
            'Psychological Testing'
        ],
        teleCons:[
            'Step 1: Download the Doctor Anywhere mobile app on Google Play Store or the App Store.',
            'Step 2: Sign up using your email address.',
            'Step 3: Select \'Profile\', then select \'My Info\'.',
            'Step 4: Select \'Corporate Insurance / Benefits\'.',
            'Step 5: Select Philippines and tap on \'Next\'',
            'Step 6: Select HMI',
            'Step 7: Enter your 6-digit Membership/HMI Number and Full Name (First Name and Last name)',
            'Step 8: Once verified you can begin using Doctor Anywhere'
        ],
        loaOpan1s:[
            'Name of member:',
            'HMI ID number:',
            'HMI Member\'s Contact Number:',
            'Scanned copy of the Doctor\'s request slip indicating the diagnosis and procedure/s to be done: (if consultation has already done)',
            'Name of Requesting Doctor:',
            'Name of Hospital/Clinic where the procedure will be done: (if for consult, please state "consultation")',
            'Date of procedure:',
            'Copy of Any Valid ID:',
            'Copy of HMI card:'
        ]
    })
}
</script>

<style scoped>
.faqs-col-content {
  width: 700px;
  margin: 20px auto;
  /* border: 1px solid red; */
}
.faqs-col-content h3 {
  font-size: 30px;
}

.faqs-col-content h4 {
  width: 80%;
  margin-top: 20px;
  text-align: justify;
  color: #1b5e20;
}

.faqs-col-content ul {
  width: 80%;
}
.faqs-col-content ul li {
  padding-top: 15px;
  font-size: 17px;
  text-align: justify;
}

@media (max-width: 599px) {
  .faqs-col-content h3 {
    text-align: center;
    font-size: 25px;
  }

  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .faqs-col-content {
    width: 95%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .faqs-col-content {
    width: 95%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .faqs-col-content {
    width: 45%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}
</style>
